
<template>
<div>

  <div v-if="page_count > 1" class="mt-2">
    <dlnkpagination
        :page="page"
        :page_count="page_count"
        @next_page="next_page()"
        @prev_page="prev_page()"
        @set_page="set_page($event)">
    </dlnkpagination>
  </div>


  <div v-if="surveys.length > 0" class="space-1 container">
    <div class="row">
      <div v-for="survey in surveys" :key="survey.id" class="col-sm-6 col-lg-4 mb-3 mb-sm-8">
        <div class="card h-100">
          <div class="card-header">
            <h5 class="mb-0">{{survey.title}}</h5>
          </div>

          <div class="card-body">
            <p v-if="survey.total_votes > 0" class="bg-light rounded text-center p-2 mx-auto">
              {{survey.total_votes}}&nbsp;réponse<span v-if="survey.total_votes > 1">s</span>
            </p>
            <p>{{survey.description}}</p>
          </div>

          <div class="card-footer mt-auto text-center border-top-0 pt-0">
            <a class="btn btn-primary btn-pill" :href="'/module/dlnksurveys/survey?id=' + survey.id">Participer</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="alert alert-info alert-dismissible" role="alert">
    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
    Aucun sondage pour le moment
  </div>
</div>



</template>


<script>

export default {
  props: ['group_id'],
  data: function () {
    return {
      message: '',
      messsage_type: '',
      wait_data: Boolean,

      page: 1,
      page_count: Number,

      survey: Object,
      surveys: [],

      admin: false,
    }
  },
  mounted() {
    this.wait_data = true
    this.get_data()
  },

  computed: {
  },

  methods: {

    set_page: function (page) {
      page = parseInt(page)
      this.page = page
    },

    next_page: function () {
      this.page++
    },

    prev_page: function () {
      this.page--
    },


    close_message: function () {
      this.message = null;
    },


    get_data: function () {
      this.get_surveys()
    },

    delete_survey: function(survey_id) {
      const _this = this
      this.wait_data = true

      get_token_2().then(function (response) {
        let group = ''
        let [secure_key, customer_id, api_url, customer] = response
        api_url += `surveys/${surveys_id}.json`
        api_url += '?secure_key=' + secure_key
        api_url += '&customer_id=' + customer_id

        axios.delete(api_url)
            .then(function (response) {
              _this.get_data()
              _this.message = "Sondage correctement supprimé.";
              _this.message_type = "alert-success"
            })
            .catch(function (error) {
              console.log(error)
            })
            .then(function () {
                  // always executed
                }
            );
      })
    },

    get_surveys: function () {
      const _this = this
      get_token_2().then(function (response) {
        let group = ''
        let [secure_key, customer_id, api_url, customer] = response
        api_url += "surveys.json"
        api_url += '?secure_key=' + secure_key
        api_url += '&customer_id=' + customer_id

        if (typeof _this.group_id !== 'undefined') {
          api_url += '&group_id=' + _this.group_id
        }

        axios.get(api_url)
            .then(function (response) {
              _this.surveys = response.data.surveys
              _this.page = response.data.meta.page
              _this.page_count = response.data.meta.pages
            })
            .catch(function (error) {
              console.log(error)
            })
            .then(function () {
              _this.wait_data = false
            });
      })
    },
  },
}
</script>